import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Layout from '../../../layout/Layout'
import OrdersList from 'components/organisms/OrdersList/OrdersList'
import BreadcrumbTitle from 'components/atoms/BreadcrumbTitle/BreadcrumbTitle'
import HeaderPageSection from 'components/molecules/HeaderPageSection/HeaderPageSection'
import { ordersList } from 'services/ordersService'
import { AppDispatch, RootState } from '../../../store/store'
import { Outlet, useNavigate } from 'react-router-dom'
import { OrdersFilters } from 'interfaces/order'
import Pagination from 'components/molecules/Pagination/Pagination'
import SearchFilter from 'components/molecules/SearchFilter/SearchFilter'
import { setState } from '../../../store/slices/order/orderSlice'
import { LoaderTransparent } from 'components/molecules/LoaderTransparent/LoaderTransparent'
import { ButtonDropdown } from 'components/molecules/ButtonDropdown/ButtonDropdown'
import AppButton from 'components/atoms/AppButton/AppButton'
import Icon from 'assets/uploadPreAlert.png'
import { usePermissions } from 'hooks/usePermissions'
import { RolePermissions } from 'utils/constants'
interface Filter {
    search: string | null
    states: string[]
    date: {
        start: Date | null
        end: Date | null
    }
}

const OrdersListPage = () => {
    const navigate = useNavigate()
    const { apiToken } = useSelector((state: RootState) => state.auth)
    const dispatch: AppDispatch = useDispatch()
    const { can } = usePermissions()
    const { items } = useSelector((state: RootState) => state.order)
    const [loading, setLoading] = useState(false)
    const canCreateOrder = can(RolePermissions.orders.create)
    const [pagination, setPagination] = useState({
        totalItems: 10,
        page: 1,
        itemsPerPage: 10,
    })
    const [filtersData, setFiltersData] = useState({
        created_before_than: null as Date | null,
        created_after_than: null as Date | null,
        states: '',
        description: '' as string | null,
    })

    const sendOrder = async (data: OrdersFilters, apiToken: string) => {
        setLoading(true)
        const result = await ordersList(data, apiToken)
        dispatch(setState({ ...result, loading: false }))
        setPagination({
            page: result.page,
            totalItems: result.totalItems,
            itemsPerPage: result.size,
        })
        setLoading(false)
    }

    const changePage = (page: number) => {
        setPagination((prevState) => ({
            ...prevState,
            page: page,
        }))
        sendOrder(
            {
                ...filtersData,
                page: page,
            },
            apiToken
        )
    }

    useEffect(() => {
        async function updateOrders() {
            sendOrder(
                {
                    created_before_than: null,
                    created_after_than: null,
                    states: '',
                    description: '',
                    page: pagination.page,
                },
                apiToken
            )
        }
        updateOrders()
    }, [apiToken])

    const updateFilters = async (filters: Filter) => {
        const data = {
            created_before_than: filters.date.end,
            created_after_than: filters.date.start,
            states: filters.states.join(','),
            description: filters.search != null ? filters.search : '',
        }
        if (JSON.stringify(data) !== JSON.stringify(filtersData)) {
            sendOrder({ ...data, page: 1 }, apiToken)
        }
        setFiltersData(data)
    }

    return (
        <Layout>
            {loading && <LoaderTransparent />}
            <Outlet />
            {loading && <LoaderTransparent />}
            <HeaderPageSection>
                <div className="flex gap-4 items-center">
                    {canCreateOrder && (
                        <>
                            <AppButton
                                icon={<img src={Icon} alt="icon" />}
                                title="Prealertar paquetes"
                                state="ghost"
                                onClick={() => navigate('/packages/create')}
                            />

                            <ButtonDropdown
                                title={'Cargar orden'}
                                options={[
                                    {
                                        title: 'Sin criterios',
                                        path: '/orders/create/no-template',
                                    },
                                    {
                                        title: 'Con criterios',
                                        path: '/orders/create/template',
                                    },
                                ]}
                                color={'primary'}
                            />
                        </>
                    )}
                </div>
            </HeaderPageSection>
            <div className="px-5">
                <BreadcrumbTitle
                    title="Órdenes"
                    subtitle="Visualizar información de órdenes y filtrar busquedas."
                />
            </div>
            <SearchFilter onChange={(f) => updateFilters(f)} />
            {Array.isArray(items) && (
                <div style={{ height: '500px', overflowY: 'auto' }}>
                    {' '}
                    {items.length > 0 ? (
                        <OrdersList orders={items} />
                    ) : (
                        <div className="flex justify-center p-4 text-sm">
                            no hay órdenes para mostrar
                        </div>
                    )}
                </div>
            )}
            <div className="flex justify-center mt-10">
                <Pagination
                    totalPages={Math.ceil(
                        pagination.totalItems / pagination.itemsPerPage
                    )}
                    currentPage={pagination.page}
                    onPageChange={(page) => changePage(page)}
                />
            </div>
        </Layout>
    )
}

export default OrdersListPage
